module.exports = __webpack_public_path__ + "img/3-3.0668fb03.jpg";